module.exports = __webpack_public_path__ + "static/media/surya.cad721a5.ogg";